import { render, staticRenderFns } from "./SummarizingLotsList.vue?vue&type=template&id=3b11c23e&"
import script from "./SummarizingLotsList.vue?vue&type=script&lang=js&"
export * from "./SummarizingLotsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports